const commonTestIds = {
	modalWindow: 'modalWindow',
};

export default commonTestIds;
